import type {z} from "zod";

import {ListClientsQueryParams} from "@project/sdk/sales/zod";

export const listClientsSearchSchema = ListClientsQueryParams.extend({
  page: ListClientsQueryParams.shape.page.catch(1).default(1),
  perPage: ListClientsQueryParams.shape.perPage.catch(20).default(20),
  q: ListClientsQueryParams.shape.q.catch(undefined),
  sortKey: ListClientsQueryParams.shape.sortKey.catch("clientId"),
  sortDir: ListClientsQueryParams.shape.sortDir.catch("asc").default("asc"),
  state: ListClientsQueryParams.shape.state.catch("ACTIVE"),
  countryCodes: ListClientsQueryParams.shape.countryCodes.catch(undefined),
  environments: ListClientsQueryParams.shape.environments.catch(undefined),
  createdFrom: ListClientsQueryParams.shape.createdFrom.catch(undefined),
  createdBefore: ListClientsQueryParams.shape.createdBefore.catch(undefined),
});

export type ListClientsSearchInput = z.input<typeof listClientsSearchSchema>;
export type ListClientsSearch = z.output<typeof listClientsSearchSchema>;
